// Complete the product action prices for approved finish matrices over 250 variants.
function sportovaCompleteActionVariants(data, form) {
  const picker = form?.closest('.sportova-product')?.querySelector('variant-radios, variant-selects');
  const full = picker?.getVariantData?.() || [];
  const reference = full.find(variant => data[String(variant.id)] && Number(variant.price) > 0);
  if (!reference) return data;
  const context = data[String(reference.id)];
  const ratio = Number(context.price) / Number(reference.price);
  const currency = context.currency || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency}).format(cents / 100);
  for (const variant of full) {
    if (data[String(variant.id)]) continue;
    const price = Math.round(Number(variant.price) * ratio);
    const tariff = Math.round(price * 0.075);
    const tradePercent = Number(context.trade_percent || 0);
    data[String(variant.id)] = {
      ...context, title: variant.title, available: variant.available, price,
      trade_price: Math.floor(price * (100 - tradePercent) / 100),
      price_money: money(price), tariff, tariff_money: money(tariff),
      total_with_tariff_money: money(price + tariff)
    };
  }
  return data;
}

class SportovaHeroCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-sportova-slide]'));
    this.current = 0;
    this.interval = Number(this.dataset.interval || 6) * 1000;
    this.autoplay = this.dataset.autoplay === 'true';
    this.querySelectorAll('[data-sportova-next]').forEach((button) => button.addEventListener('click', () => this.go(1)));
    this.querySelectorAll('[data-sportova-prev]').forEach((button) => button.addEventListener('click', () => this.go(-1)));
    if (this.autoplay && this.slides.length > 1) this.start();
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  start() {
    this.timer = window.setInterval(() => this.go(1), this.interval);
  }

  go(direction) {
    if (this.slides.length < 2) return;
    this.slides[this.current].classList.remove('is-active');
    this.current = (this.current + direction + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.add('is-active');
  }
}

class SportovaTariffAcknowledgement extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.error = this.querySelector('[data-tariff-error]');
    this.amount = this.querySelector('[data-sportova-tariff-amount]');
    this.amountText = this.querySelector('[data-sportova-tariff-amount-text]');
    this.submitButton = this.form?.querySelector('[type="submit"][name="add"]');
    this.submitLabel = this.form?.querySelector('[data-sportova-add-label]');
    this.submitPrice = this.form?.querySelector('[data-sportova-add-price]');
    this.submitTotal = this.form?.querySelector('[data-sportova-add-total]');
    this.variantData = this.parseVariantData();
    this.moneyProperty = this.form?.querySelector('[data-sportova-tariff-property-money]');
    this.centsProperty = this.form?.querySelector('[data-sportova-tariff-property-cents]');
    this.publicCentsProperty = this.form?.querySelector('[data-sportova-tariff-property-public-cents]');
    this.quantityInput = this.form?.querySelector('[name="quantity"]') || document.querySelector(`[form="${this.form?.getAttribute('id')}"][name="quantity"]`);
    this.currentVariantId = this.form?.querySelector('.product-variant-id')?.value || '';
    this.acceptedBeforeAmount = false;
    if (!this.form || !this.checkbox) return;
    this.observeSubmitButton();
    this.form.addEventListener('change', () => window.setTimeout(() => {
      const variantInput = this.form?.querySelector('.product-variant-id');
      if (variantInput?.value) this.currentVariantId = String(variantInput.value);
      this.updateForCurrentVariant();
    }, 0));
    this.form.addEventListener('sportova:swatches-changed', () => this.updateForCurrentVariant());
    this.quantityInput?.addEventListener('input', () => this.updateForCurrentVariant());
    this.quantityInput?.addEventListener('change', () => this.updateForCurrentVariant());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId && !String(this.form.getAttribute('id') || '').includes(event.data.sectionId)) return;
        if (event?.data?.variant?.id) this.currentVariantId = String(event.data.variant.id);
        window.setTimeout(() => this.updateForCurrentVariant(), 0);
      });
    }
    this.checkbox.addEventListener('change', () => {
      this.classList.remove('has-error');
      this.error.hidden = true;
      if (this.checkbox.checked && this.amountText?.hidden) this.acceptedBeforeAmount = true;
      this.updateForCurrentVariant();
    });
    this.form.addEventListener('submit', (event) => {
      this.updateForCurrentVariant();
      if (this.isInquiryVariantSelected()) return;
      if (this.getPendingSwatchLabels().length) return;
      if (this.checkbox.checked) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.error.hidden = false;
      this.classList.remove('has-error');
      void this.offsetWidth;
      this.classList.add('has-error');
      this.checkbox.focus();
    }, true);
    this.updateForCurrentVariant();
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    if (this.submitButtonObserver) this.submitButtonObserver.disconnect();
  }

  parseVariantData() {
    const script = this.querySelector('[data-sportova-tariff-variants]');
    if (!script) return {};
    try {
      return sportovaCompleteActionVariants(JSON.parse(script.textContent), this.form);
    } catch (error) {
      return {};
    }
  }

  updateForCurrentVariant() {
    const variantInput = this.form?.querySelector('.product-variant-id');
    const variantId = variantInput?.value || this.currentVariantId || '';
    const data = variantId ? this.variantData[variantId] : null;
    if (!data) {
      this.clearTariffAmount();
      return;
    }
    if (variantInput && variantInput.value !== variantId) variantInput.value = variantId;
    this.ensureSubmitPriceMarkup();
    if (this.isInquiryVariantSelected()) {
      this.classList.remove('has-error');
      if (this.error) this.error.hidden = true;
      if (this.checkbox) this.checkbox.checked = false;
      this.acceptedBeforeAmount = false;
      this.clearTariffAmount();
      if (this.submitLabel) this.submitLabel.textContent = 'Inquire';
      if (this.submitPrice) this.submitPrice.textContent = '';
      if (this.submitTotal) {
        this.submitTotal.textContent = '';
        this.submitTotal.hidden = true;
      }
      return;
    }
    const pendingSwatches = this.getPendingSwatchLabels();
    const waitingForSwatches = pendingSwatches.length > 0;
    this.hidden = false;
    if (waitingForSwatches) {
      this.classList.remove('has-error');
      if (this.error) this.error.hidden = true;
      if (this.checkbox) this.checkbox.checked = false;
      this.clearTariffAmount();
      if (this.submitLabel) this.submitLabel.textContent = this.getPendingSwatchButtonLabel(pendingSwatches);
      if (this.submitPrice) this.submitPrice.textContent = '';
      if (this.submitTotal) {
        this.submitTotal.textContent = '';
        this.submitTotal.hidden = true;
      }
      return;
    }
    if (this.submitLabel) this.submitLabel.textContent = 'Add to cart';
    this.setTariffAmount(data);
    if (this.acceptedBeforeAmount) {
      this.checkbox.checked = false;
      this.acceptedBeforeAmount = false;
    }
    const quantity = Math.max(1, Number(this.quantityInput?.value || 1));
    const price = data.is_trade_customer && Number(data.trade_percent || 0) > 0
      ? Number(data.trade_price || data.price || 0)
      : Number(data.price || 0);
    const tariff = Number(data.tariff || 0);
    const displayCents = (price + (this.checkbox?.checked ? tariff : 0)) * quantity;
    const pricePrefix = data.is_trade_customer && Number(data.trade_percent || 0) > 0 ? 'Trade ' : '';
    if (this.submitPrice) this.submitPrice.textContent = `${pricePrefix}${this.formatMoney(displayCents, data.currency)}`;
    if (this.submitTotal) {
      this.submitTotal.textContent = '';
      this.submitTotal.hidden = true;
    }
    if (this.moneyProperty) this.moneyProperty.value = data.tariff_money;
    if (this.centsProperty) this.centsProperty.value = data.tariff;
    if (this.publicCentsProperty) this.publicCentsProperty.value = data.tariff;
  }

  clearTariffAmount() {
    if (this.amount) this.amount.textContent = '';
    if (this.amountText) this.amountText.hidden = true;
    if (this.moneyProperty) this.moneyProperty.value = '';
    if (this.centsProperty) this.centsProperty.value = '';
    if (this.publicCentsProperty) this.publicCentsProperty.value = '';
  }

  setTariffAmount(data) {
    if (this.amount) this.amount.textContent = data.tariff_money;
    if (this.amountText) this.amountText.hidden = false;
  }

  getPendingSwatchLabels() {
    const product = this.form?.closest('.sportova-product');
    return Array.from(product?.querySelectorAll('.product-form__input:has(.sportova-swatch)') || [])
      .filter((fieldset) => fieldset.dataset.sportovaSwatchTouched !== 'true')
      .map((fieldset) => fieldset.querySelector('.form__label')?.textContent?.trim())
      .filter(Boolean);
  }

  getPendingSwatchButtonLabel(labels) {
    const finishPattern = /(wood|leather|finish|color|colour|fabric|upholstery|material|metal|steel|cork|rope)/i;
    if (labels.length >= 3 && labels.every((label) => finishPattern.test(label))) {
      return 'Select finishes';
    }

    return `Select ${labels.join(' and ').toLowerCase()}`;
  }

  isInquiryVariantSelected() {
    const product = this.form?.closest('.sportova-product');
    const selectedOptions = Array.from(product?.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select') || [])
      .map((input) => input.tagName === 'SELECT' ? input.value : input.value)
      .filter(Boolean)
      .join(' / ');
    return /custom\s*size|inquire/i.test(selectedOptions);
  }

  formatMoney(cents, currency = 'USD') {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (_error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  ensureSubmitPriceMarkup() {
    if (!this.submitButton) this.submitButton = this.form?.querySelector('[type="submit"][name="add"]');
    const wrapper = this.submitButton?.querySelector('span');
    if (!wrapper) return;
    this.submitPrice = wrapper.querySelector('[data-sportova-add-price]');
    this.submitTotal = wrapper.querySelector('[data-sportova-add-total]');
    this.submitLabel = wrapper.querySelector('[data-sportova-add-label]');
    if (this.submitPrice && this.submitTotal) return;
    this.repairingSubmitButton = true;
    wrapper.innerHTML = '<span data-sportova-add-label>Add to cart</span><span class="sportova-add-prices"><span data-sportova-add-price></span><span data-sportova-add-total hidden></span></span>';
    this.submitLabel = wrapper.querySelector('[data-sportova-add-label]');
    this.submitPrice = wrapper.querySelector('[data-sportova-add-price]');
    this.submitTotal = wrapper.querySelector('[data-sportova-add-total]');
    this.repairingSubmitButton = false;
  }

  observeSubmitButton() {
    if (!this.submitButton) return;
    const wrapper = this.submitButton.querySelector('span');
    if (!wrapper) return;
    this.submitButtonObserver = new MutationObserver(() => {
      if (this.repairingSubmitButton) return;
      window.setTimeout(() => this.updateForCurrentVariant(), 0);
    });
    this.submitButtonObserver.observe(wrapper, { childList: true, subtree: true, characterData: true });
  }
}

class SportovaAddButtonPrice {
  constructor(form) {
    this.form = form;
    this.productForm = form.closest('product-form');
    this.product = form.closest('.sportova-product');
    this.submitButton = form.querySelector('[type="submit"][name="add"]');
    this.variantInput = form.querySelector('.product-variant-id');
    this.quantityInput = form.querySelector('[name="quantity"]') || document.querySelector(`[form="${form.id}"][name="quantity"]`);
    this.variantData = this.parseVariantData();
    this.onChange = () => window.setTimeout(() => this.update(), 0);
  }

  init() {
    if (!this.form || !this.submitButton || !this.variantInput || !Object.keys(this.variantData).length) return;
    if (this.form.querySelector('sportova-tariff-acknowledgement')) return;
    this.ensureSubmitPriceMarkup();
    this.form.addEventListener('change', this.onChange);
    this.form.addEventListener('sportova:swatches-changed', this.onChange);
    this.quantityInput?.addEventListener('input', this.onChange);
    this.quantityInput?.addEventListener('change', this.onChange);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.productForm?.dataset.sectionId;
        if (event?.data?.sectionId && sectionId && event.data.sectionId !== sectionId) return;
        this.update();
      });
    }
    this.update();
  }

  parseVariantData() {
    const script = this.form.querySelector('[data-sportova-add-button-variants]');
    if (!script) return {};
    try {
      return sportovaCompleteActionVariants(JSON.parse(script.textContent), this.form);
    } catch (_error) {
      return {};
    }
  }

  update() {
    this.ensureSubmitPriceMarkup();
    const data = this.variantData[this.variantInput?.value];
    if (!data || !this.submitLabel || !this.submitPrice) return;
    if (this.isInquiryVariantSelected(data)) {
      this.submitLabel.textContent = 'Inquire';
      this.submitPrice.textContent = '';
      if (this.submitTotal) {
        this.submitTotal.textContent = '';
        this.submitTotal.hidden = true;
      }
      return;
    }
    const pendingSwatches = this.getPendingSwatchLabels();
    if (pendingSwatches.length) {
      this.submitLabel.textContent = this.getPendingSwatchButtonLabel(pendingSwatches);
      this.submitPrice.textContent = '';
      if (this.submitTotal) {
        this.submitTotal.textContent = '';
        this.submitTotal.hidden = true;
      }
      return;
    }
    this.submitLabel.textContent = 'Add to cart';
    const quantity = Math.max(1, Number(this.quantityInput?.value || 1));
    const unitPrice = data.is_trade_customer && Number(data.trade_percent || 0) > 0
      ? Number(data.trade_price || data.price || 0)
      : Number(data.price || 0);
    const pricePrefix = data.is_trade_customer && Number(data.trade_percent || 0) > 0 ? 'Trade ' : '';
    this.submitPrice.textContent = `${pricePrefix}${this.formatMoney(unitPrice * quantity, data.currency)}`;
    if (this.submitTotal) {
      this.submitTotal.textContent = '';
      this.submitTotal.hidden = true;
    }
  }

  getPendingSwatchLabels() {
    return Array.from(this.product?.querySelectorAll('.product-form__input:has(.sportova-swatch)') || [])
      .filter((fieldset) => fieldset.dataset.sportovaSwatchTouched !== 'true')
      .map((fieldset) => fieldset.querySelector('.form__label')?.textContent?.trim())
      .filter(Boolean);
  }

  getPendingSwatchButtonLabel(labels) {
    const finishPattern = /(wood|leather|finish|color|colour|fabric|upholstery|material|metal|steel|cork|rope)/i;
    if (labels.length >= 3 && labels.every((label) => finishPattern.test(label))) {
      return 'Select finishes';
    }

    return `Select ${labels.join(' and ').toLowerCase()}`;
  }

  isInquiryVariantSelected(data) {
    const selectedOptions = Array.from(this.product?.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select') || [])
      .map((input) => input.value)
      .filter(Boolean)
      .join(' / ');
    return /custom\s*size|inquire/i.test(`${selectedOptions} ${data.title || ''}`);
  }

  formatMoney(cents, currency = 'USD') {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (_error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  ensureSubmitPriceMarkup() {
    const wrapper = this.submitButton?.querySelector('span');
    if (!wrapper) return;
    this.submitPrice = wrapper.querySelector('[data-sportova-add-price]');
    this.submitTotal = wrapper.querySelector('[data-sportova-add-total]');
    this.submitLabel = wrapper.querySelector('[data-sportova-add-label]');
    if (this.submitPrice && this.submitTotal && this.submitLabel) return;
    wrapper.innerHTML = '<span data-sportova-add-label>Add to cart</span><span class="sportova-add-prices"><span data-sportova-add-price></span><span data-sportova-add-total hidden></span></span>';
    this.submitLabel = wrapper.querySelector('[data-sportova-add-label]');
    this.submitPrice = wrapper.querySelector('[data-sportova-add-price]');
    this.submitTotal = wrapper.querySelector('[data-sportova-add-total]');
  }
}

function initSportovaAddButtonPrices(root = document) {
  root.querySelectorAll('.sportova-product product-form form[data-type="add-to-cart-form"]').forEach((form) => {
    if (form.dataset.sportovaAddButtonPriceInitialized === 'true') return;
    form.dataset.sportovaAddButtonPriceInitialized = 'true';
    new SportovaAddButtonPrice(form).init();
  });
}

class SportovaProductInquiry extends HTMLElement {
  connectedCallback() {
    if (this.dataset.sportovaInquiryInitialized === 'true') return;
    this.dataset.sportovaInquiryInitialized = 'true';
    this.form = this.querySelector('form');
    this.productForm = this.closest('product-form');
    this.addForm = this.productForm?.querySelector('form[data-type="add-to-cart-form"]');
    this.addButton = this.productForm?.querySelector('[type="submit"][name="add"]');
    this.submitLabel = this.addButton?.querySelector('[data-sportova-add-label]');
    this.modal = this;
    if (this.parentElement !== document.body) document.body.appendChild(this);
    this.dialog = this.modal?.querySelector('.sportova-product-inquiry__dialog');
    this.variantInput = this.productForm?.querySelector('.product-variant-id');
    this.variantField = this.modal?.querySelector('[data-sportova-product-inquiry-variant]');
    this.messageField = this.modal?.querySelector('[data-sportova-product-inquiry-message]');
    this.defaultSubmitLabel = this.submitLabel?.textContent?.trim() || 'Add to cart';
    this.onInquiryFormSubmit = this.onInquiryFormSubmit.bind(this);
    if (!this.productForm || !this.addForm || !this.addButton || !this.modal) return;

    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddFormSubmit = this.onAddFormSubmit.bind(this);
    this.addButton.addEventListener('click', this.onAddButtonClick, true);
    this.addForm.addEventListener('submit', this.onAddFormSubmit, true);
    this.form?.addEventListener('submit', this.onInquiryFormSubmit, true);
    this.customSizeButton = this.productForm.querySelector('[data-sportova-custom-size-inquiry]');
    this.onCustomSizeClick = () => {
      this.open();
      if (this.variantField) this.variantField.value = 'Custom size / ' + this.getCurrentVariantTitle();
      if (this.messageField && !this.messageField.value) this.messageField.value = 'I would like a custom size. Required dimensions (inches): ';
    };
    this.customSizeButton?.addEventListener('click', this.onCustomSizeClick);
    this.modal.querySelectorAll('[data-sportova-product-inquiry-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });
    this.productForm.addEventListener('change', () => window.setTimeout(() => this.updateForCurrentVariant(), 0));
    this.variantInput?.addEventListener('change', () => this.updateForCurrentVariant());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.productForm.dataset.sectionId;
        if (event?.data?.sectionId && sectionId && event.data.sectionId !== sectionId) return;
        window.setTimeout(() => this.updateForCurrentVariant(), 0);
      });
    }
    this.updateForCurrentVariant();
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    this.addButton?.removeEventListener('click', this.onAddButtonClick, true);
    this.addForm?.removeEventListener('submit', this.onAddFormSubmit, true);
    this.form?.removeEventListener('submit', this.onInquiryFormSubmit, true);
    this.customSizeButton?.removeEventListener('click', this.onCustomSizeClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }

  getCurrentVariantTitle() {
    const sectionId = this.productForm?.dataset.sectionId;
    const variantPicker = sectionId ? document.querySelector(`variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`) : null;
    const variantId = this.variantInput?.value;
    let variant = null;
    try {
      variant = variantPicker?.getVariantData?.().find((entry) => String(entry.id) === String(variantId));
    } catch (_error) {
      variant = null;
    }
    if (variant?.title) return variant.title;
    const selectedOptions = Array.from(variantPicker?.querySelectorAll(':checked') || []).map((input) => input.value).filter(Boolean);
    return selectedOptions.join(' / ');
  }

  isInquiryVariant() {
    return /custom\s*size|inquire/i.test(this.getCurrentVariantTitle());
  }

  updateForCurrentVariant() {
    const isInquiry = this.isInquiryVariant();
    this.productForm.classList.toggle('sportova-product-form--inquiry-active', isInquiry);
    this.productForm.closest('.sportova-product')?.classList.toggle('sportova-product--inquiry-active', isInquiry);
    if (isInquiry) {
      if (this.submitLabel) this.submitLabel.textContent = 'Inquire';
      this.addButton.removeAttribute('disabled');
      this.addButton.removeAttribute('aria-disabled');
      if (this.variantField) this.variantField.value = this.getCurrentVariantTitle();
      return;
    }
    if (this.submitLabel) this.submitLabel.textContent = this.defaultSubmitLabel;
    if (!this.modal.hidden) this.close();
  }

  onAddFormSubmit(event) {
    this.updateForCurrentVariant();
    if (!this.isInquiryVariant()) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.open();
  }

  onAddButtonClick(event) {
    this.updateForCurrentVariant();
    if (!this.isInquiryVariant()) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.open();
  }

  open() {
    this.updateForCurrentVariant();
    this.activeOpener = document.activeElement;
    this.modal.hidden = false;
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sportova-product-inquiry-open');
    document.addEventListener('keydown', this.onDocumentKeydown);
    window.requestAnimationFrame(() => {
      this.dialog?.focus();
      this.modal.querySelector('input:not([type="hidden"]), textarea, button[type="submit"]')?.focus();
    });
  }

  close() {
    this.modal.hidden = true;
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sportova-product-inquiry-open');
    document.removeEventListener('keydown', this.onDocumentKeydown);
    this.activeOpener?.focus?.();
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  onInquiryFormSubmit() {
    if (!this.messageField) return;
    const productTitle = this.dataset.productTitle || document.querySelector('.product__title h1')?.textContent?.trim() || '';
    const productUrl = this.dataset.productUrl || window.location.href;
    const variant = this.getCurrentVariantTitle();
    const header = [
      productTitle ? `Product: ${productTitle}` : '',
      productUrl ? `Product URL: ${productUrl}` : '',
      variant ? `Variant: ${variant}` : '',
    ].filter(Boolean).join('\n');
    if (!header || this.messageField.value.includes(header)) return;
    const customerMessage = this.messageField.value.trim();
    this.messageField.value = customerMessage ? `${header}\n\n${customerMessage}` : header;
  }
}

function initSportovaProductActions(root = document) {
  root.querySelectorAll('.sportova-product .product__info-container').forEach((info) => {
    if (info.dataset.sportovaActionsInitialized === 'true') return;
    const quantity = info.querySelector('.product-form__quantity');
    const form = info.querySelector('product-form');
    if (!quantity || !form) return;
    const tariff = form.querySelector('sportova-tariff-acknowledgement');
    if (tariff) quantity.before(tariff);
    const row = document.createElement('div');
    row.className = 'sportova-product__actions';
    quantity.before(row);
    row.append(quantity, form);
    info.dataset.sportovaActionsInitialized = 'true';
  });
}

class SportovaSearchOverlay extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-sportova-search-input]');
    this.results = this.querySelector('[data-sportova-search-results]');
    this.form = this.querySelector('[data-sportova-search-form]');
    this.emptyMarkup = this.results ? this.results.innerHTML : '';
    this.abortController = null;
    this.cache = {};
    this.debounceTimer = null;

    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onDocumentKeydown.bind(this));
    this.input?.addEventListener('input', this.onInput.bind(this));
    this.input?.addEventListener('keydown', this.onInputKeydown.bind(this));
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
    this.results?.addEventListener('click', this.onResultsClick.bind(this));
  }

  onDocumentClick(event) {
    const opener = event.target.closest('[data-sportova-search-open]');
    if (opener) {
      event.preventDefault();
      this.open(opener);
      return;
    }

    if (event.target.closest('[data-sportova-search-close]')) {
      event.preventDefault();
      this.close();
    }
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape' && !this.hidden) this.close();
  }

  onSubmit(event) {
    event.preventDefault();
    this.searchCurrentTerm();
  }

  onResultsClick(event) {
    const directLink = event.target.closest('a[href]');
    if (directLink) return;

    const resultItem = event.target.closest('.predictive-search__list-item, .card-wrapper, .card');
    const link = resultItem?.querySelector('a[href]');
    if (!link) return;

    event.preventDefault();
    window.location.href = link.href;
  }

  onInputKeydown(event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    this.searchCurrentTerm();
  }

  searchCurrentTerm() {
    const term = this.input?.value.trim();
    if (!term) return;
    window.clearTimeout(this.debounceTimer);
    this.fetchResults(term);
  }

  onInput() {
    window.clearTimeout(this.debounceTimer);
    const term = this.input.value.trim();

    if (!term) {
      this.clearResults();
      return;
    }

    this.debounceTimer = window.setTimeout(() => this.fetchResults(term), 140);
  }

  open(opener) {
    this.activeOpener = opener || document.activeElement;
    this.hidden = false;
    document.body.classList.add('sportova-search-open');
    document.querySelectorAll('[data-sportova-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    window.requestAnimationFrame(() => this.input?.focus());
  }

  close() {
    this.hidden = true;
    document.body.classList.remove('sportova-search-open');
    document.querySelectorAll('[data-sportova-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    this.activeOpener?.focus?.();
  }

  clearResults() {
    if (this.abortController) this.abortController.abort();
    this.results.innerHTML = this.emptyMarkup;
    this.removeAttribute('loading');
    this.removeAttribute('results');
  }

  fetchResults(term) {
    const key = term.toLowerCase();
    if (this.cache[key]) {
      this.renderResults(this.cache[key]);
      return;
    }

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    this.setAttribute('loading', '');

    const endpoint = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=24&section_id=predictive-search`;

    fetch(endpoint, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search')?.innerHTML;
        const markup = html || '<p class="sportova-search-overlay__empty">No results found.</p>';
        this.cache[key] = markup;
        this.renderResults(markup);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        this.results.innerHTML = '<p class="sportova-search-overlay__empty">Search is temporarily unavailable.</p>';
      })
      .finally(() => this.removeAttribute('loading'));
  }

  renderResults(markup) {
    this.results.innerHTML = markup;
    this.setAttribute('results', '');
  }
}

function initGalerieIndex(root = document) {
  root.querySelectorAll('[data-galerie-index]').forEach((index) => {
    if (index.dataset.galerieInitialized === 'true') return;
    index.dataset.galerieInitialized = 'true';

    const cards = Array.from(index.querySelectorAll('[data-galerie-card]'));
    const filters = Array.from(index.querySelectorAll('[data-galerie-filter]'));
    const pagination = index.querySelector('[data-galerie-pagination]');
    const empty = index.querySelector('[data-galerie-empty]');
    const perPage = Math.max(1, Number(index.dataset.galeriePerPage || 12));
    let activeFilter = 'all';
    let currentPage = 1;

    cards
      .sort((cardA, cardB) => (Date.parse(cardB.dataset.projectDate || '') || 0) - (Date.parse(cardA.dataset.projectDate || '') || 0))
      .forEach((card) => card.parentElement?.append(card));

    const matchingCards = () => cards.filter((card) => activeFilter === 'all' || card.dataset.category === activeFilter);

    const render = () => {
      const matches = matchingCards();
      const pageCount = Math.max(1, Math.ceil(matches.length / perPage));
      currentPage = Math.min(currentPage, pageCount);
      const start = (currentPage - 1) * perPage;
      const visible = new Set(matches.slice(start, start + perPage));

      cards.forEach((card) => {
        card.hidden = !visible.has(card);
      });

      if (empty) empty.hidden = matches.length > 0;
      renderPagination(pageCount);
    };

    const renderPagination = (pageCount) => {
      if (!pagination) return;
      pagination.innerHTML = '';
      pagination.hidden = pageCount <= 1;
      if (pageCount <= 1) return;

      const makeButton = (label, page, isActive = false, isDisabled = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.disabled = isDisabled;
        button.className = isActive ? 'is-active' : '';
        button.addEventListener('click', () => {
          currentPage = page;
          render();
          index.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return button;
      };

      pagination.append(makeButton('Previous', Math.max(1, currentPage - 1), false, currentPage === 1));
      for (let page = 1; page <= pageCount; page += 1) {
        pagination.append(makeButton(String(page), page, page === currentPage));
      }
      pagination.append(makeButton('Next', Math.min(pageCount, currentPage + 1), false, currentPage === pageCount));
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.galerieFilter || 'all';
        currentPage = 1;
        filters.forEach((filter) => filter.classList.toggle('is-active', filter === button));
        render();
      });
    });

    render();
  });
}

function initGalerieProjects(root = document) {
  root.querySelectorAll('[data-galerie-project]').forEach((project) => {
    if (project.dataset.galerieInitialized === 'true') return;
    project.dataset.galerieInitialized = 'true';

    // Match the listing order, including every record beyond Liquid's default first 50.
    try {
      const navigation = JSON.parse(project.querySelector('[data-galerie-navigation]')?.textContent || '[]')
        .sort((a, b) => (Date.parse(b.date || '') || 0) - (Date.parse(a.date || '') || 0));
      const position = navigation.findIndex((item) => item.handle === project.dataset.projectHandle);
      if (position >= 0 && navigation.length > 1) {
        const previousProject = navigation[(position - 1 + navigation.length) % navigation.length];
        const nextProject = navigation[(position + 1) % navigation.length];
        project.querySelectorAll('nav[aria-label="Project navigation"] a').forEach((link) => {
          if (link.textContent.trim() === 'Previous Project') link.href = previousProject.url;
          if (link.textContent.trim() === 'Next Project') link.href = nextProject.url;
        });
      }
    } catch (_error) { /* Retain server-rendered navigation if metadata is unavailable. */ }

    const slides = Array.from(project.querySelectorAll('[data-galerie-slide]'));
    const thumbs = Array.from(project.querySelectorAll('[data-galerie-thumb]'));
    const prev = project.querySelector('[data-galerie-prev]');
    const next = project.querySelector('[data-galerie-next]');
    const copyButton = project.querySelector('[data-copy-link]');
    const lightbox = project.querySelector('[data-galerie-lightbox]');
    const lightboxImage = project.querySelector('[data-galerie-lightbox-image]');
    const imageData = project.querySelector('[data-galerie-images]');
    let images = [];
    let current = 0;

    try {
      images = imageData ? JSON.parse(imageData.textContent || '[]') : [];
    } catch (_error) {
      images = [];
    }

    const show = (nextIndex) => {
      if (!slides.length) return;
      current = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === current));
      thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === current));
      updateLightboxImage();
    };

    const updateLightboxImage = () => {
      if (!lightboxImage || !images[current]) return;
      lightboxImage.src = images[current].src;
      lightboxImage.alt = images[current].alt || '';
    };

    const openLightbox = (startIndex) => {
      if (!lightbox || !images.length) return;
      current = startIndex;
      show(current);
      lightbox.hidden = false;
      document.body.classList.add('galerie-lightbox-open');
      lightbox.querySelector('[data-galerie-lightbox-close]')?.focus();
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.classList.remove('galerie-lightbox-open');
    };

    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));

    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => openLightbox(index));
    });
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => show(index));
    });

    project.querySelector('[data-galerie-lightbox-close]')?.addEventListener('click', closeLightbox);
    project.querySelector('[data-galerie-lightbox-prev]')?.addEventListener('click', () => show(current - 1));
    project.querySelector('[data-galerie-lightbox-next]')?.addEventListener('click', () => show(current + 1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });

    copyButton?.addEventListener('click', () => {
      const url = copyButton.dataset.copyLink || window.location.href;
      navigator.clipboard?.writeText(url).then(() => {
        const original = copyButton.textContent;
        copyButton.textContent = 'Copied';
        window.setTimeout(() => {
          copyButton.textContent = original;
        }, 1800);
      });
    });

    show(0);
  });
}

function initSportovaCartAcknowledgement(root = document) {
  root.querySelectorAll('cart-drawer').forEach((drawer) => {
    if (drawer.dataset.sportovaAckInitialized === 'true') return;
    drawer.dataset.sportovaAckInitialized = 'true';
    drawer.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-cart-acknowledgement]');
      if (!checkbox) return;
      const label = checkbox.closest('.sportova-cart-ack');
      const error = drawer.querySelector('[data-cart-acknowledgement-error]');
      label?.classList.remove('has-error');
      if (error) error.hidden = true;
    });
    drawer.addEventListener('click', (event) => {
      const checkout = event.target.closest('[name="checkout"], #CartDrawer-Checkout');
      if (!checkout) return;
      const checkbox = drawer.querySelector('[data-cart-acknowledgement]');
      if (!checkbox || checkbox.checked) return;
      event.preventDefault();
      event.stopPropagation();
      const label = checkbox.closest('.sportova-cart-ack');
      const error = drawer.querySelector('[data-cart-acknowledgement-error]');
      if (error) error.hidden = false;
      label?.classList.remove('has-error');
      void label?.offsetWidth;
      label?.classList.add('has-error');
      checkbox.focus();
    }, true);
    drawer.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') return;
      const checkbox = drawer.querySelector('[data-cart-acknowledgement]');
      if (!checkbox || checkbox.checked) return;
      event.preventDefault();
      event.stopPropagation();
      const label = checkbox.closest('.sportova-cart-ack');
      const error = drawer.querySelector('[data-cart-acknowledgement-error]');
      if (error) error.hidden = false;
      label?.classList.add('has-error');
      checkbox.focus();
    }, true);
  });
}

function initSportovaRequiredSwatches(root = document) {
  root.querySelectorAll('.sportova-product .product-form__input:has(.sportova-swatches)').forEach((fieldset) => {
    if (fieldset.dataset.sportovaSwatchesInitialized === 'true') return;
    if (!fieldset.querySelector('.sportova-swatch')) return;
    fieldset.dataset.sportovaSwatchesInitialized = 'true';
    // A valid deep link already identifies a complete purchasable variant.
    // Only acknowledge option groups belonging to that variant selector.
    const requestedVariant = new URLSearchParams(window.location.search).get('variant');
    const productRoot = fieldset.closest('.sportova-product');
    const linkedVariantInput = productRoot?.querySelector('product-form form .product-variant-id');
    const hasLinkedVariant = /^\d+$/.test(requestedVariant || '')
      && linkedVariantInput?.value === requestedVariant
      && Boolean(fieldset.closest('variant-radios, variant-selects'));
    fieldset.dataset.sportovaSwatchTouched = hasLinkedVariant ? 'true' : 'false';
    fieldset.querySelectorAll('.sportova-swatch').forEach((swatch) => {
      const input = swatch.htmlFor ? document.getElementById(swatch.htmlFor) : null;
      swatch.classList.toggle('is-selected', Boolean(hasLinkedVariant && input?.checked));
    });

    fieldset.addEventListener('focusin', (event) => {
      const input = event.target.closest('input[type="radio"]');
      fieldset.querySelectorAll('.sportova-swatch').forEach((swatch) => {
        swatch.classList.toggle('is-keyboard-focused', Boolean(input && swatch.htmlFor === input.id));
      });
    });
    fieldset.addEventListener('focusout', () => {
      fieldset.querySelectorAll('.is-keyboard-focused').forEach((swatch) => swatch.classList.remove('is-keyboard-focused'));
    });

    const legend = fieldset.querySelector('.form__label')?.textContent?.trim() || 'option';
    const error = document.createElement('p');
    error.className = 'sportova-swatch-error';
    error.hidden = true;
    error.textContent = `Please select ${legend}.`;
    fieldset.append(error);
    const form = fieldset.closest('.sportova-product')?.querySelector('product-form form');
    const notifySwatchesChanged = () => form?.dispatchEvent(new CustomEvent('sportova:swatches-changed', { bubbles: true }));
    if (hasLinkedVariant) window.setTimeout(notifySwatchesChanged, 0);

    fieldset.addEventListener('click', (event) => {
      const selected = event.target.closest('.sportova-swatch');
      if (!selected) return;
      fieldset.dataset.sportovaSwatchTouched = 'true';
      fieldset.classList.remove('has-swatch-error');
      error.hidden = true;
      fieldset.querySelectorAll('.sportova-swatch').forEach((swatch) => swatch.classList.toggle('is-selected', swatch === selected));
      notifySwatchesChanged();
    });

    fieldset.addEventListener('change', (event) => {
      const input = event.target.closest('input[type="radio"]');
      if (!input) return;
      fieldset.dataset.sportovaSwatchTouched = 'true';
      fieldset.classList.remove('has-swatch-error');
      error.hidden = true;
      const selected = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      fieldset.querySelectorAll('.sportova-swatch').forEach((swatch) => swatch.classList.toggle('is-selected', swatch === selected));
      notifySwatchesChanged();
    });
  });

  root.querySelectorAll('.sportova-product product-form form').forEach((form) => {
    if (form.dataset.sportovaSwatchGateInitialized === 'true') return;
    form.dataset.sportovaSwatchGateInitialized = 'true';
    form.addEventListener('submit', (event) => {
      const product = form.closest('.sportova-product');
      const untouched = Array.from(product?.querySelectorAll('.product-form__input:has(.sportova-swatch)') || []).filter(
        (fieldset) => fieldset.dataset.sportovaSwatchTouched !== 'true'
      );
      if (!untouched.length) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      untouched.forEach((fieldset) => {
        fieldset.classList.remove('has-swatch-error');
        void fieldset.offsetWidth;
        fieldset.classList.add('has-swatch-error');
        const error = fieldset.querySelector('.sportova-swatch-error');
        if (error) error.hidden = false;
      });
      untouched[0].querySelector('.sportova-swatch')?.focus?.();
    }, true);
  });
}

async function loadSelectedVariantMedia(product, picker, selectedVariant, galleries) {
  const mediaId = selectedVariant?.featured_media?.id;
  if (!mediaId || galleries.some((gallery) => gallery.querySelector(`[data-media-id="${picker.dataset.section}-${mediaId}"]`))) return;

  const loadingKey = `variantMedia${mediaId}`;
  if (product.dataset[loadingKey] === 'true') {
    await new Promise((resolve) => window.setTimeout(resolve, 100));
    return;
  }
  product.dataset[loadingKey] = 'true';

  try {
    const productInfo = product.closest('product-info') || product.querySelector('product-info');
    const productUrl = productInfo?.dataset.url || window.location.pathname;
    const response = await fetch(window.sportovaProductVariantURL ? window.sportovaProductVariantURL(productUrl, selectedVariant.id, picker.dataset.section) : `${productUrl}?variant=${selectedVariant.id}&section_id=${picker.dataset.section}`);
    if (!response.ok) throw new Error(`Unable to load variant media (${response.status})`);

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const modalId = `ProductModal-${picker.dataset.section}`;
    const sourceModal = html.getElementById(modalId);
    const currentModal = document.getElementById(modalId);
    const sourceModalMedia = sourceModal?.querySelector(`.product-media-modal__content > [data-media-id="${mediaId}"]`);
    const currentModalContent = currentModal?.querySelector('.product-media-modal__content');
    if (sourceModalMedia && currentModalContent && !currentModalContent.querySelector(`:scope > [data-media-id="${mediaId}"]`)) {
      currentModalContent.appendChild(sourceModalMedia.cloneNode(true));
    }

    galleries.forEach((gallery) => {
      const sourceGallery = html.querySelector(`#${CSS.escape(gallery.id)}`);
      const mediaTarget = `${picker.dataset.section}-${mediaId}`;
      const sourceMedia = sourceGallery?.querySelector(`[data-media-id="${mediaTarget}"]`);
      if (sourceMedia && !gallery.querySelector(`[data-media-id="${mediaTarget}"]`)) {
        const viewer = gallery.querySelector('[id^="GalleryViewer"]');
        const pentSlide = viewer?.querySelector('[data-media-id*="pent-3d"]');
        const insertionPoint = pentSlide?.parentElement === viewer ? pentSlide : null;
        viewer?.insertBefore(sourceMedia.cloneNode(true), insertionPoint);
      }

      const sourceThumbnail = sourceGallery?.querySelector(`[data-target="${mediaTarget}"]`);
      if (sourceThumbnail && !gallery.querySelector(`[data-target="${mediaTarget}"]`)) {
        const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"] .thumbnail-list') || gallery.querySelector('[id^="GalleryThumbnails"]');
        const pentThumbnail = thumbnails?.querySelector('[data-target*="pent-3d"]');
        const insertionPoint = pentThumbnail?.parentElement === thumbnails ? pentThumbnail : null;
        thumbnails?.insertBefore(sourceThumbnail.cloneNode(true), insertionPoint);
        const insertedButton = gallery.querySelector(`[data-target="${mediaTarget}"] button`);
        insertedButton?.addEventListener('click', () => gallery.setActiveMedia(mediaTarget, false));
      }
    });
  } finally {
    delete product.dataset[loadingKey];
  }
}

function syncPent3dAfterExplicitSwatchSelection(event) {
  const product = event.target.closest?.('.sportova-product');
  const picker = product?.querySelector('variant-radios, variant-selects');
  const pentViewer = product?.querySelector('pent-3d-viewer');
  if (!picker || (pentViewer && pentViewer.dataset.section !== picker.dataset.section)) return;

  const immediateGroups = [...picker.querySelectorAll('.product-form__input:has(.sportova-swatch)')];
  const immediateConfigurationReady = immediateGroups.length > 0
    && immediateGroups.every((group) => group.dataset.sportovaSwatchTouched === 'true');
  if (immediateConfigurationReady && pentViewer?.dataset.preferredView !== '3d') {
    product.querySelectorAll(`[id^="MediaGallery-${picker.dataset.section}"] .product__media-item.is-active .product__media img`)
      .forEach((image) => image.classList.add('sportova-variant-image--pending'));
  }

  window.setTimeout(async () => {
    const groups = [...picker.querySelectorAll('.product-form__input:has(.sportova-swatch)')];
    const allGroupsTouched = groups.length > 0 && groups.every((group) => group.dataset.sportovaSwatchTouched === 'true');
    if (!groups.length || !allGroupsTouched) {
      const galleries = product.querySelectorAll(`[id^="MediaGallery-${picker.dataset.section}"]`);
      galleries.forEach((gallery) => {
        gallery.querySelectorAll('.sportova-variant-image--pending').forEach((image) => image.classList.remove('sportova-variant-image--pending'));
        gallery.querySelectorAll('[data-media-id*="pent-3d"]').forEach((item) => item.classList.add('pent-3d-awaiting-selection'));
        if (pentViewer?.dataset.fallbackMediaId) gallery.setActiveMedia(pentViewer.dataset.fallbackMediaId, false);
      });
      if (pentViewer) pentViewer.dataset.preferredView = 'image';
      return;
    }

    const selectedOptions = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')]
      .map((group) => group.querySelector('input[type="radio"]:checked')?.value || group.querySelector('select')?.value);
    const variantData = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const selectedVariant = variantData.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]));
    const galleries = product.querySelectorAll(`[id^="MediaGallery-${picker.dataset.section}"]`);

    const posterImage = pentViewer?.querySelector('.pent-3d-viewer__poster img');
    const posterSource = selectedVariant?.featured_media?.preview_image?.src;
    if (posterImage && posterSource) {
      const normalizedPosterSource = posterSource.startsWith('//') ? `${window.location.protocol}${posterSource}` : posterSource;
      if (posterImage.src !== normalizedPosterSource) {
        posterImage.removeAttribute('srcset');
        posterImage.removeAttribute('sizes');
        posterImage.src = normalizedPosterSource;
      }
    }

    if (selectedVariant?.featured_media?.id) {
      try {
        await loadSelectedVariantMedia(product, picker, selectedVariant, [...galleries]);
      } catch (error) {
        console.error(error);
        galleries.forEach((gallery) => gallery.querySelectorAll('.sportova-variant-image--pending')
          .forEach((image) => image.classList.remove('sportova-variant-image--pending')));
      }
    }

    // Ignore a slow earlier selection after the customer has chosen another finish.
    const currentOptions = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')]
      .map(group => group.querySelector('input[type="radio"]:checked')?.value || group.querySelector('select')?.value);
    if (!selectedVariant?.options.every((option, index) => option === currentOptions[index])) return;
    galleries.forEach((gallery) => {
      gallery.querySelectorAll('.pent-3d-awaiting-selection').forEach((item) => item.classList.remove('pent-3d-awaiting-selection'));
      const pentWasActive = pentViewer?.dataset.preferredView === '3d' || gallery.querySelector('[data-media-id*="pent-3d"].is-active');
      if (pentWasActive) {
        gallery.querySelectorAll('.sportova-variant-image--pending').forEach((image) => image.classList.remove('sportova-variant-image--pending'));
        gallery.setActiveMedia(pentViewer.dataset.galleryId, false);
      } else if (selectedVariant?.featured_media?.id) {
        gallery.setActiveMedia(`${picker.dataset.section}-${selectedVariant.featured_media.id}`, true);
      } else {
        // Products without finish-specific photos retain their clear supplier gallery.
        gallery.querySelectorAll('.sportova-variant-image--pending')
          .forEach((image) => image.classList.remove('sportova-variant-image--pending'));
      }
    });
  }, 0);
}

function initJoanaAccordionStability(root = document) {
  root.querySelectorAll('.pent-joana-product-page .sportova-product__accordion > summary').forEach((summary) => {
    if (summary.dataset.joanaStableAccordion === 'true') return;
    summary.dataset.joanaStableAccordion = 'true';
    summary.addEventListener('click', () => {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      const scrollPosition = window.scrollY;
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        if (Math.abs(window.scrollY - scrollPosition) > 1) window.scrollTo({ top: scrollPosition, behavior: 'auto' });
      }));
    });
  });
}

function beginPent3dLoading(viewer) {
  if (!viewer || ['frame-ready', 'crossfading', 'complete'].includes(viewer.dataset.transitionState)) return;
  viewer.classList.remove('pent-3d-viewer--ready');
  viewer.classList.add('pent-3d-viewer--loading');
  viewer.dataset.transitionState = 'runtime-loading';
  const poster = viewer.querySelector('.pent-3d-viewer__poster');
  const status = viewer.querySelector('.pent-3d-viewer__status');
  if (poster) poster.hidden = false;
  if (status) status.textContent = 'Loading 3D model…';
}

window.sportovaBeginPent3dLoading = window.sportovaBeginPent3dLoading || beginPent3dLoading;

document.addEventListener('DOMContentLoaded', () => {
  initGalerieIndex();
  initGalerieProjects();
  initSportovaProductActions();
  initSportovaCartAcknowledgement();
  initSportovaRequiredSwatches();
  initSportovaAddButtonPrices();
  initJoanaAccordionStability();
  if (new URLSearchParams(window.location.search).get('pent-render') === '1') {
    const viewer = document.querySelector('pent-3d-viewer');
    const gallery = viewer?.closest('media-gallery');
    if (viewer && gallery) {
      viewer.dataset.preferredView = '3d';
      gallery.setActiveMedia?.(viewer.dataset.galleryId, false);
      if (!customElements.get('pent-3d-viewer') && !document.querySelector('script[data-pent3d-runtime], script[data-pent-3d-runtime]')) {
        const runtime = document.createElement('script');
        runtime.src = viewer.dataset.runtime;
        runtime.dataset.pent3dRuntime = 'true';
        runtime.addEventListener('load', () => viewer.activate?.(), { once: true });
        document.head.appendChild(runtime);
      } else {
        viewer.activate?.();
      }
    }
  }
  document.addEventListener('click', (event) => {
    const pentButton = event.target.closest('.pent-3d-thumbnail');
    if (pentButton) {
      const gallery = pentButton.closest('media-gallery');
      const viewer = gallery?.querySelector('pent-3d-viewer');
      if (gallery && viewer) {
        viewer.dataset.preferredView = '3d';
        beginPent3dLoading(viewer);
        gallery.setActiveMedia?.(viewer.dataset.galleryId, false);
        const existingRuntime = document.querySelector('script[data-pent3d-runtime], script[data-pent-3d-runtime]');
        if (customElements.get('pent-3d-viewer')) {
          viewer.activate?.();
        } else if (!existingRuntime) {
          const runtime = document.createElement('script');
          runtime.src = viewer.dataset.runtime;
          runtime.dataset.pent3dRuntime = 'true';
          runtime.addEventListener('load', () => viewer.activate?.(), { once: true });
          runtime.addEventListener('error', () => {
            viewer.classList.remove('pent-3d-viewer--loading');
            viewer.dataset.transitionState = 'failed';
            const status = viewer.querySelector('.pent-3d-viewer__status');
            if (status) status.textContent = '3D view could not load';
          }, { once: true });
          document.head.appendChild(runtime);
        } else {
          existingRuntime.addEventListener('load', () => viewer.activate?.(), { once: true });
        }
      }
    }
    const swatch = event.target.closest('.sportova-swatch');
    if (!swatch) return;
    const group = swatch.closest('.sportova-swatches');
    group?.querySelectorAll('.sportova-swatch').forEach((item) => item.classList.toggle('is-selected', item === swatch));
  });
});

document.addEventListener('sportova:swatches-changed', syncPent3dAfterExplicitSwatchSelection);
document.addEventListener('change', (event) => {
  if (!event.target.closest?.('variant-radios, variant-selects')) return;
  syncPent3dAfterExplicitSwatchSelection(event);
});

document.addEventListener('shopify:section:load', (event) => {
  initGalerieIndex(event.target);
  initGalerieProjects(event.target);
  initSportovaProductActions(event.target);
  initSportovaCartAcknowledgement(event.target);
  initSportovaRequiredSwatches(event.target);
  initSportovaAddButtonPrices(event.target);
  initJoanaAccordionStability(event.target);
});

customElements.define('sportova-hero-carousel', SportovaHeroCarousel);
customElements.define('sportova-tariff-acknowledgement', SportovaTariffAcknowledgement);
customElements.define('sportova-product-inquiry', SportovaProductInquiry);
customElements.define('sportova-search-overlay', SportovaSearchOverlay);
